module.exports = __webpack_public_path__ + "img/1522043784.689a904b.jpg";